import { type PropsWithChildren, useEffect, useState } from "react";
import { useShowFlash } from "@sprout/flash.tsx";
import useTranslation from "@hooks/use_translation.ts";
import OtherError from "@/pages/other_error.tsx";

// When we make requests using Inertia's router instead of Axios, Inertia expects
// an Inertia response. There are some cases where we expect the server to send
// responses that Inertia will be unable to handle. This error boundary catches
// those events and cancels them, showing a toast message instead.
export const InertiaErrorBoundary = ({ children }: PropsWithChildren) => {
  const showFlash = useShowFlash();
  const { t } = useTranslation("misc");
  const [showOtherError, setShowOtherError] = useState(false);

  useEffect(() => {
    const handleError = (event: CustomEvent) => {
      // This is the error code we get back from Rack::Attack when throttling a user
      if (event.detail?.response?.status === 429) {
        event.preventDefault();
        showFlash(t("429.flash"), "error");
      } else {
        event.preventDefault();
        setShowOtherError(true);
      }
    };

    document.addEventListener("inertia:invalid", handleError);

    return () => {
      document.removeEventListener("inertia:invalid", handleError);
    };
  });

  return showOtherError ? <OtherError /> : <>{children}</>;
};
